import React from "react";
import Loading from "./Loading";

export default function Pagination({ pagination }: { pagination: Pagination }) {
  return pagination.show ? (
    <div className="center mt1 mb1">
      {pagination.loading ? (
        <Loading />
      ) : (
        <button
          className="ib reset as-link"
          onClick={() => pagination.viewMore()}
        >
          <small>view more</small>
        </button>
      )}
    </div>
  ) : null;
}
